import { apiService } from './apiService';

export const basePriceService = {
  async getAll() {
    return apiService.get('/base-prices');
  },

  async create(data: any) {
    return apiService.post('/base-prices', data);
  },

  async update(id: string | number, data: any) {
    return apiService.put(`/base-prices/${id}`, data);
  },

  async delete(id: string | number) {
    return apiService.delete(`/base-prices/${id}`);
  },

  async bulkDelete(ids: Array<string | number>) {
    return apiService.post('/base-prices/bulk-delete', { ids }, { timeoutMs: 120000 });
  },

  async bulkImport(rows: any[]) {
    return apiService.post('/base-prices/bulk-import', { rows });
  },

  async bulkUpdatePriorities(rows: any[]) {
    return apiService.post('/base-prices/bulk-update-priorities', { rows });
  },

  async backfillValidity() {
    return apiService.post('/base-prices/backfill-validity', undefined, { timeoutMs: 120000 });
  },
};
